namespace OfficeGuy.Inputs {
    export class RadioButtonList {
        static Init() {
            $(document).on("click", ".og-radiolist-item", function () {
                var $Label = $(this);
                var $Checkbox = $Label.find("input");
                var $RadioList = $Label.closest(".og-radiolist");
                if ($RadioList.hasClass("og-radiolist-disabled"))
                    return false;
                if ($RadioList.hasClass("og-radiolist-required") && $Checkbox[0].checked)
                    return false;

                $Checkbox.prop("checked", !$Checkbox[0].checked).trigger("change");
                return false;
            });
            $(document).on("change", ".og-radiolist-item-input", function () {
                var Checked = this.checked;
                var $Label = $(this).closest(".og-radiolist-item");
                if (Checked == $Label.hasClass('og-radiolist-item-selected'))
                    return;

                var $RadioList = $Label.closest(".og-radiolist");
                if ($RadioList.hasClass("og-radiolist-disabled"))
                    return;

                $Label.closest(".og-radiolist").find(".og-radiolist-item-selected").removeClass("og-radiolist-item-selected");
                $Label.toggleClass("og-radiolist-item-selected", Checked);
            });
        }

        static ToggleColor(Container: Element): boolean {
            var $Checkbox = $("> input", Container);
            $Checkbox.prop("checked", !$Checkbox.prop("checked"));
            return false;
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Inputs.RadioButtonList.Init();
});
